<template>
  <div v-if="justView">
    <div class="applicable">
      <button
        style="background: #d1d1d1;"
        :class="`applicabled-button applicable-button-${itemId}`"
      >
        <span class="d-md-none d-sm-block d-xs-block">Não aplica</span>
        <span class="d-none d-sm-none d-xs-none d-md-block">{{this.$i18n.locale === 'br' ? 'Não aplicável' : this.$i18n.locale === 'us' ? 'Not applicable' : 'No aplicable' }}</span>
      </button>
    </div>
  </div>
   <div v-else>
    <div v-if="btnBlock" :style="(
      btnBlock ? {
        padding: 0,
        paddingLeft: '8px',
        paddingRight: '8px',
        display: 'flex',
        flexDirection: 'column',
        textalign: 'center',
      } : '')">
      <div class="applicable" :style="(
        btnBlock ? {
          width: '100%',
          paddingLeft: 0,
        } : '')">
        <button
          :style="(
            btnBlock ? {
              width: '100%',
            } : '')"
          :class="`applicabled-button applicable-button-${itemId}`"
          @click="setButton(selectedButton)"
        >
          <span class="d-md-none d-sm-block d-xs-block">{{lang === 'br' ? 'Não aplica' : lang === 'us' ? 'Not apply' : 'No se aplica' }}</span>
          <span class="d-none d-sm-none d-xs-none d-md-block">{{lang === 'br' ? 'Não aplicável' : lang === 'us' ? 'Not applicable' : 'No aplicable' }}</span>
        </button>
      </div>
    </div>

    <div v-else-if="btnBlockLikert" class="btn-block-likert">
      <div class="applicable" style="padding-left: 0;">
        <button style="width: 100%;"
          :class="`applicabled-button applicable-button-${itemId}`"
          @click="setButton(selectedButton)"
        >
          <span class="d-md-none d-sm-block d-xs-block">{{lang === 'br' ? 'Não aplica' : lang === 'us' ? 'Not apply' : 'No se aplica' }}</span>
          <span class="d-none d-sm-none d-xs-none d-md-block">{{lang === 'br' ? 'Não aplicável' : lang === 'us' ? 'Not applicable' : 'No aplicable' }}</span>
        </button>
      </div>
    </div>

    <div v-else>
      <div class="applicable">
        <button
          :class="`applicabled-button applicable-button-${itemId}`"
          @click="setButton(selectedButton)"
        >
          <span class="d-md-none d-sm-block d-xs-block">{{lang === 'br' ? 'Não aplica' : lang === 'us' ? 'Not apply' : 'No se aplica' }}</span>
          <span class="d-none d-sm-none d-xs-none d-md-block">{{lang === 'br' ? 'Não aplicável' : lang === 'us' ? 'Not applicable' : 'No aplicable' }}</span>
        </button>
      </div>
    </div>
   </div>
</template>

<script>
import EventBus from '../../../../eventBus';

export default {
  name: 'Applicable',

  data: () => ({
    displayApplicable: false,
  }),

  props: {
    itemId: { type: Number, required: true },
    justView: { type: Boolean, default: false },
    selectedButton: { type: Boolean, default: false },
    btnBlock: { type: Boolean, default: false },
    btnBlockLikert: { type: Boolean, default: false },
    lang: { type: String, default: 'br' },
  },

  watch: {
    selectedButton: function watchComment() {
      if (this.selectedButton) {
        document.querySelector(
          `.applicable-button-${this.itemId}`,
        ).style.background = '#d1d1d1';
      } else {
        document.querySelector(
          `.applicable-button-${this.itemId}`,
        ).style.background = '#ffffff';
      }
    },
  },

  methods: {
    setButton(value) {
      if (value) {
        this.review = -1;
        this.$emit('input', this.review);
      }
    },
  },

  created() {
  }
};
</script>

<style scoped lang="scss">
.applicable {
  padding-top: 15px;
  padding-left: 15px;
}

.applicabled-button {
  border-radius: 0.2rem;
  color: #5f6368;
  border: 1px solid #5f6368;
  background: #ffffff;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}

.btn-block-likert {
  width: 100%; padding-left: 8px; margin-top: -5px;
  display: flex; flex-direction: column;
  justify-content: center; text-align: center
}

.btn-block-likert button {
  height: 43px;
}
@media screen and (max-width: 1200px) {
  .btn-block-likert {
    padding-left: 0;
    margin-top: 0;
  }
}

// .applicable-button {
//   border-radius: 5px;
//   color: #5f6368;
//   border-color: #f1f1f1;
//   background: #ffffff;
// }

// .applicable-button:hover {
//   background: #f0f0f0;
//   color: #c1c1c1;
// }

// .applicable-button:focus {
//   background: #f0f0f0;
//   color: #c1c1c1;
// }
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/applicable/index.vue